import React from 'react';

const MyRecoveryPlan = () => {
  return <div><h1>My Recovery Plan</h1></div>;
};

export default MyRecoveryPlan;
